import { useMutation } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_MFA_ENROLL } from "consts";

export default function useMfaEnroll(config) {
  return useMutation(
    ({ accessToken, confirmationCode, mfaMode }) =>
      postWithBearer(
        API_MFA_ENROLL,
        { confirmationCode, mfaMode },
        accessToken
      ),
    config
  );
}
